module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("8")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELGA")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S PRIVATE NURSES")]), _vm._v(", by coincidence, is South African, a Coloured woman, part white, part Xhosa, or so she says, from the Cape province.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why are you in England?” Helga asks her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is afternoon, the room is bright, Arnold is gone, Bridget is in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I mean, why would you leave South Africa now that things are beginning to look so promising?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How promising?” the nurse says. “Things are terrible where I come from. No jobs. Crime everywhere. It’s hard here, but at least here you know where you stand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Surely things are better for you now,” Helga says. “Or at least for your children in the new South Africa. Here you’re a nobody.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m not a nobody,” the nurse says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If it were not Helga, if things were not what they are, she might be angry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Look,” the nurse says, “I come from a part of the Cape called the Flats. Do you know where that is, near Cape Town?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course I do,” Helga says, but despite her emphatic tone the nurse is not so sure, or certain even that Helga is following the conversation. There is a faraway look in her eyes, as if she is focused on something very distant and complex.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“When I was a girl it was hard, true,” the nurse says. “The government pushed us into the Cape Flats because they didn’t know what to do with us Coloureds. But it was home anyway, and we always believed that things would get better. Now, it’s like the Wild West there. Horrible. There’s no respect for anything.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Helga purses her lips and nods, but she looks perplexed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You don’t like what’s happened?” she asks distractedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course not,” the woman says. “I even voted for the National Party in the last election before I left.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Helga raises her eyebrows, keeps nodding, says nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I know you think I must be crazy, a Coloured woman voting for the party of "), _c('em', [_vm._v("apartheid")]), _vm._v(",” the nurse says. “But the National Party carried my part of the Cape Flats and there’s only Coloureds there. The whites have all the money, and the blacks think they own the place, but for us who aren’t one thing and who aren’t the other things are not simple. The quality of life’s gone downhill every day since that Mandela got out of prison.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m surprised,” Helga says. “Nothing is turning out as it should. And we worked so hard for change.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Were you involved in politics, Helga?” the nurse asks, suddenly much gentler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Was I involved?” Helga repeats. “Of course I was involved. I ran for Parliament.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is the nurse who is now confused. She knows Helga wafts in and out of dementia, sees no trace now of a person who can have done such a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s nice,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Helga pauses, looks around the room, appears confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I never took much interest in politics, to be quite honest,” the nurse says at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bridget comes into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you comfortable, Mommella?” she asks.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("“Why wouldn’t I be?” Helga says. “With all the care I’m getting.” And then she adds, wistfully: “Yes. Those were they days. They certainly were.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What days?” Bridget asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nothing,” Helga answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Later the nurse, troubled by it, corners Bridget in the kitchen and asks: “Did your mother run for Parliament?” and Bridget, busy preparing something or other, answers off-handedly: “Twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yes. Twice. Picture this. Durban City Hall, March, 1970. There is an election in the offing and the Prime Minister has flown to the city to debate several local figures on the correctness of the government’s "), _c('em', [_vm._v("apartheid")]), _vm._v(" policies. My mother, who is an opposition candidate, has been selected to present the opposing view. The Prime Minister goes first and makes his points ham-handedly and at length. Who hasn’t heard them by now? South Africa is not one nation but many, an accident of history in fact, and to correct the accident each nation must now be given its own autonomous region, the whites theirs, the Zulu’s what is historically theirs, the Xhosa theirs, "), _c('em', [_vm._v("ad nauseam.")]), _vm._v(" Each group can have all the civil rights in the world, but only after it has been consolidated in its own place.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("And then it is my mother’s turn. She wears a navy suit, has waving auburn hair, cuts an unbearably elegant figure on the auditorium’s ornate and massive stage. She starts softly, points out that this so-called white nation of the Prime Minister sits, by coincidence, on all the country’s mineral wealth, encompasses all of its factories and cities and good farmland and ports and universities, and that even so it cannot function, not for a day, not for a moment, without cheap black labor, lots and lots of cheap black labor, and thus is an apparition from the start. “And so I ask the Honourable Prime Minister,” she says, her voice rising, “how this grand scheme of his can ever work, how he will ever accomplish this unscrambling of a long-cooked egg without causing dislocation and suffering, and in the process creating anger and resentment on a scale we can scarcely imagine tonight in this ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("lovely hall? Why is it so hard to acknowledge the obvious, the common humanity of all who are blessed to live in this country, to acknowledge that we are all South Africans, all entitled to basic rights and freedoms and regardless of the color of our skins? Because the solution to the problems history has handed us will only be found in this acknowledgment. Mark my words. "), _c('em', [_vm._v("Time will prove them to be true")]), _vm._v(".”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The applause from the faithful begins before she is finished. It continues long after she is done.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337103c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/015_Chapter08.vue
// module id = 105
// module chunks = 0